import { cycleRecommendationClientSrc17Evid864 } from '@wix/bi-logger-premium-data/v2';
import { CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { toServedCycleLabel, useCycleDefaultDecision } from '../useCycleDefaultDecision';
import { useSelectedCycle } from '../useSelectedCycle';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
export const useInitCycleDefaultBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  const {
    commonBiEventsFields,
    isLoading
  } = useCommonBiEventsFields();
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onCycleDefaultServed', params => {
      biLogger == null || biLogger.report(cycleRecommendationClientSrc17Evid864({
        ...commonBiEventsFields,
        ...params
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields]);
  const {
    productFamily,
    recommendedCycle,
    availableCycles,
    applied,
    fallbackReason,
    correlationId,
    isEligible,
    isProductLoading,
    isLoading: isDecisionLoading
  } = useCycleDefaultDecision();
  const selectedCycle = useSelectedCycle();
  const reportedFamilies = React.useRef(new Set());
  const servedCycle = toServedCycleLabel(selectedCycle);
  const dedupKey = productFamily ?? 'unknown';
  React.useEffect(() => {
    if (!didInit || isDecisionLoading || isProductLoading || !servedCycle || reportedFamilies.current.has(dedupKey)) {
      return;
    }
    reportedFamilies.current.add(dedupKey);
    module.internals.bi.onCycleDefaultServed == null || module.internals.bi.onCycleDefaultServed({
      correlationId,
      productFamily,
      servedCycle,
      recommendedCycle,
      applied,
      fallbackReason,
      availableCycles: availableCycles.map(cycle => CycleUtils.convertCycleToCycleId(cycle)).join(','),
      experimentLabel: isEligible ? 'B' : 'A'
    });
  }, [didInit, isDecisionLoading, isProductLoading, servedCycle, dedupKey, module, correlationId, productFamily, recommendedCycle, applied, fallbackReason, availableCycles, isEligible]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitCycleDefaultBiEvents.js.map